import { useQuery } from "@tanstack/react-query";
import { reportService } from "@/features/reports/services/reportService";
import { queryKeys } from "@/lib/query-keys";
import type { Department } from "@/types/department";
import { useGovernanceAllowedDepartments } from "@/hooks/useDepartmentScope";

export function useReportScope() {
  return useQuery({
    queryKey: queryKeys.reports.scope(),
    queryFn: () => reportService.getScope(),
  });
}

/** Departments visible in report filters — scoped for Sub-Admins. */
export function useScopedDepartments(departments: Department[]) {
  return useGovernanceAllowedDepartments(departments);
}
